<template>
  <div class="Faq">
    <section-header heading="2" ja="よくある質問"/>
    <normal-btn @click="onAboutWeb">プリクラONについて</normal-btn>
    <normal-btn @click="onAboutIMyMerry">i my merryについて</normal-btn>
    <normal-btn @click="onAboutRomakyun">romakyunについて</normal-btn>
    <normal-btn @click="onAboutLalamee">lalameeについて</normal-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'

export default {
  name: "Faq",
  components: {
    SectionHeader,
    NormalBtn
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AppaboutWeb")
    },
    onAboutFiz() {
      this.$router.push("/AppaboutFiz")
    },
    onAboutMeiroma() {
      this.$router.push("/AppAboutMeiyromantic")
    },
    onAboutLalamee() {
      this.$router.push("/AppaboutLalamee")
    },
    onAboutROMAPI() {
      this.$router.push("/AppaboutROMAPI")
    },
    onAboutBepiu() {
      this.$router.push("/AppaboutBepiu")
    },
    onAboutRomakyun() {
      this.$router.push("/AppaboutRomakyun")
    },
    onAboutIMyMerry() {
      this.$router.push("/AppaboutIMyMerry")
    },
  }
}
</script>

<style scoped>
</style>
